import React from "react";
import { ArrowRight } from "lucide-react";
import { NLink } from "@/i18n/I18nProvider";

export const CampsComingSoon = ({ c }) => (
  <div className="text-center max-w-2xl mx-auto" data-testid="camps-coming-soon">
    <div className="overline text-[#C4A46A]">{c.openingKicker}</div>
    <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight">{c.openingTitle}</h2>
    <span className="gold-rule mt-6 mx-auto block" />
    <p className="mt-8 text-white/80 text-lg leading-relaxed">{c.openingBody}</p>
    <NLink
      to="/contact"
      data-testid="camps-coming-soon-cta"
      className="mt-10 inline-flex items-center gap-3 px-8 py-4 bg-[#C4A46A] text-[#0F1B2D] text-[12px] tracking-[0.24em] uppercase font-bold hover:bg-[#A38755] transition-colors"
    >
      {c.openingCta} <ArrowRight size={16} />
    </NLink>
  </div>
);
